import { ERROR_TYPE, HTTP_STATUS } from '../consts';
import type { NetworkError, SchemaValidationError, ApiResponseError, UnknownError } from '../types';

// Factory for network errors (e.g., network down, CORS issue, request aborted)
export const networkError = (
  message: string,
  status = HTTP_STATUS.INTERNAL_SERVER_ERROR,
  error: unknown
): NetworkError => ({
  type: ERROR_TYPE.NETWORK,
  message,
  status,
  error
});

// Factory for Zod schema validation errors - successful 2xx response but data doesn't match the expected Zod schema
export const schemaValidationError = (
  message: string,
  status = HTTP_STATUS.SCHEMA_VALIDATION_ERROR,
  error: unknown
): SchemaValidationError => ({
  type: ERROR_TYPE.SCHEMA_VALIDATION,
  message,
  status,
  error
});

// Factory for API response errors - validated error response from the server
export const apiResponseError = <T>(message: string, status: number, error: T): ApiResponseError<T> => ({
  type: ERROR_TYPE.API_RESPONSE,
  message,
  status,
  error
});

// Factory for unknown errors
export const unknownError = (message: string, status: number | undefined, error: unknown): UnknownError => ({
  type: ERROR_TYPE.UNKNOWN,
  message,
  status: status ?? HTTP_STATUS.INTERNAL_SERVER_ERROR,
  error
});
